import { useWindowScroll } from '@zoomit/primitives';

import StickySearch from './StickySearch';

const StickySearchScrollTrigger = () => {
  const [scroll] = useWindowScroll();
  const isStick = scroll.y > 200;

  if (!isStick) return;
  return <StickySearch />;
};

export default StickySearchScrollTrigger;
